/*
 * Request a Quote form behaviour — shared by sections/ew-quote-form.liquid and
 * snippets/contact-form-popup.liquid. Markup: snippets/quote-form-fields.liquid.
 *
 *   EWQuoteForm.init(form, { onSuccess: fn })
 *
 * Posts to Shopify's /contact via fetch (so the sales@ notification still goes
 * out), then mirrors the submission into Salesforce through EWSalesforce.
 * init() is idempotent; forms marked [data-quote-form] are also picked up on
 * shopify:section:load for the theme editor.
 */
(function () {
  if (window.EWQuoteForm) return;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function selectedServices(form) {
    return Array.prototype.map.call(
      form.querySelectorAll('[data-service]:checked'),
      function (el) { return el.value; }
    );
  }

  function updateConditional(form) {
    var selected = selectedServices(form);
    form.querySelectorAll('[data-show-when]').forEach(function (group) {
      var triggers = group.getAttribute('data-show-when').split('|');
      var show = triggers.some(function (t) { return selected.indexOf(t) !== -1; });
      group.hidden = !show;
      group.disabled = !show; // disabled fieldsets are left out of FormData
    });
  }

  function fillAggregates(form) {
    form.querySelectorAll('[data-quote-aggregate]').forEach(function (hidden) {
      var group = hidden.closest('fieldset');
      hidden.value = Array.prototype.map.call(
        group.querySelectorAll('input[type="checkbox"]:checked'),
        function (el) { return el.value; }
      ).join(', ');
    });
  }

  function fillAttribution(form) {
    var data = window.EWSalesforce && window.EWSalesforce.attribution
      ? window.EWSalesforce.attribution()
      : {};
    var now = new Date();
    data.submitted_at = now.toISOString() + ' (' + now.toLocaleString() + ')';
    form.querySelectorAll('[data-attr]').forEach(function (input) {
      input.value = data[input.getAttribute('data-attr')] || '';
    });
  }

  function validate(form) {
    var errors = [];
    var firstInvalid = null;

    function fail(msg, el) {
      errors.push(msg);
      if (!firstInvalid) firstInvalid = el;
    }

    var name = form.querySelector('[name="contact[Name]"]');
    var company = form.querySelector('[name="contact[Company]"]');
    var email = form.querySelector('[name="contact[email]"]');

    if (!name.value.trim()) fail('Name can\'t be blank.', name);
    if (!company.value.trim()) fail('Company name can\'t be blank.', company);
    if (!email.value.trim()) fail('Email can\'t be blank.', email);
    else if (!EMAIL_RE.test(email.value.trim())) fail('Email is invalid.', email);

    if (!selectedServices(form).length) {
      fail('Please select at least one service.', form.querySelector('[data-service]'));
    }
    if (!form.querySelector('[name="contact[Timeline]"]:checked')) {
      fail('Please tell us when you need your order.', form.querySelector('[name="contact[Timeline]"]'));
    }

    [name, company, email].forEach(function (el) {
      if (errors.length && el === firstInvalid) el.setAttribute('aria-invalid', 'true');
      else el.removeAttribute('aria-invalid');
    });

    return { errors: errors, firstInvalid: firstInvalid };
  }

  function getCaptchaWidgetId(form) {
    var iframe = form.querySelector('.h-captcha iframe[data-hcaptcha-widget-id]');
    return iframe ? iframe.getAttribute('data-hcaptcha-widget-id') : null;
  }

  function withCaptcha(form, done, failed) {
    var wid = getCaptchaWidgetId(form);
    if (!wid || !window.hcaptcha) return done();

    var result = window.hcaptcha.execute(wid, { async: true });
    if (result && typeof result.then === 'function') {
      result.then(function () { done(); }).catch(function () {
        failed('Security check failed. Please try again.');
      });
      return;
    }

    // Older hCaptcha builds: poll until the response token is populated.
    var captchaField = form.querySelector('[name="h-captcha-response"]');
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      if ((captchaField && captchaField.value) || attempts > 100) {
        clearInterval(poll);
        if (captchaField && captchaField.value) done();
        else failed('Security check timed out. Please try again.');
      }
    }, 100);
  }

  function init(form, options) {
    if (!form || form.dataset.quoteInit) return;
    form.dataset.quoteInit = 'true';
    options = options || {};

    var banner = form.querySelector('.quote-form__errors');
    var bannerList = banner && banner.querySelector('ul');
    var submitBtn = form.querySelector('[type="submit"]');
    var submitLabel = submitBtn && submitBtn.querySelector('[data-label]');
    var spinner = submitBtn && submitBtn.querySelector('[data-spinner]');

    form.setAttribute('novalidate', '');
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-service]')) updateConditional(form);
    });
    updateConditional(form);

    function showErrors(msgs) {
      if (!banner) return;
      bannerList.innerHTML = '';
      msgs.forEach(function (m) {
        var li = document.createElement('li');
        li.textContent = m;
        bannerList.appendChild(li);
      });
      banner.hidden = false;
    }

    function clearErrors() {
      if (!banner) return;
      banner.hidden = true;
      bannerList.innerHTML = '';
    }

    function setLoading(on) {
      if (submitBtn) submitBtn.disabled = on;
      if (submitLabel) submitLabel.hidden = on;
      if (spinner) spinner.hidden = !on;
    }

    function fail(msg) {
      showErrors([msg]);
      banner && banner.querySelector('[role="alert"]').focus();
      setLoading(false);
    }

    function post() {
      var formData = new FormData(form);
      // The popup captures the token early in case a page builder strips it.
      if (!formData.get('authenticity_token') && window.__contactAuthToken) {
        formData.append('authenticity_token', window.__contactAuthToken);
      }

      fetch(form.action, { method: 'POST', body: formData, credentials: 'same-origin' })
        .then(function (res) {
          if (res.url && res.url.indexOf('contact_posted=true') !== -1) {
            if (window.EWSalesforce) window.EWSalesforce.sendQuote(form);
            if (typeof gtag !== 'undefined') gtag('event', 'request_quote', {});
            form.reset();
            updateConditional(form);
            setLoading(false);
            if (typeof options.onSuccess === 'function') options.onSuccess();
            return;
          }
          return res.text().then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var msgs = Array.prototype.map.call(
              doc.querySelectorAll('.contact__field-error, .form-status-list li'),
              function (el) { return el.textContent.trim(); }
            ).filter(Boolean);
            fail(msgs.length ? msgs.join(' ') : 'Please check your details and try again.');
          });
        })
        .catch(function () {
          fail('Something went wrong. Please try again or email us directly.');
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      clearErrors();

      var result = validate(form);
      if (result.errors.length) {
        showErrors(result.errors);
        if (result.firstInvalid) result.firstInvalid.focus();
        return;
      }

      fillAggregates(form);
      fillAttribution(form);
      setLoading(true);
      withCaptcha(form, post, fail);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('form[data-quote-form]').forEach(function (form) {
      init(form, { onSuccess: function () { form.dispatchEvent(new CustomEvent('quote:success', { bubbles: true })); } });
    });
  }

  window.EWQuoteForm = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
